import { getCollectionFieldTraitOptions } from '../../pluginComponentApi';

export const StripeButton = (bm, category, label, type) => {
  bm.add(type, {
    label: `<svg height="35" viewBox="0 0 50 45" color="white" xmlns="http://www.w3.org/2000/svg">
    <g fill="#c3cfe9" fill-rule="evenodd">
    <path d="M102.473 32.722h4.489V14.934h-4.489zM124.39 18.268a7.376 7.376 0 00-2.14-2.053c-1.355-.854-3.204-1.28-5.545-1.28h-5.914v17.787h6.918c2.5 0 4.506-.817 6.02-2.453 1.514-1.635 2.27-3.805 2.27-6.508 0-2.15-.537-3.981-1.61-5.493m-7.182 10.427h-1.927v-9.734h1.954c1.373 0 2.428.43 3.168 1.287.74.857 1.11 2.073 1.11 3.647 0 3.2-1.435 4.8-4.305 4.8M18.637 0L4.09 3.81.081 18.439l5.014 5.148L0 28.65l3.773 14.693 14.484 4.047 5.096-5.064 5.014 5.147 14.547-3.81 4.008-14.63-5.013-5.146 5.095-5.063L43.231 4.13 28.745.083l-5.094 5.063zM9.71 6.624l7.663-2.008 3.351 3.44-4.887 4.856zm16.822 1.478l3.405-3.383 7.63 2.132-6.227 6.187zM4.672 17.238l2.111-7.705 6.125 6.288-4.886 4.856zm29.547-1.243l6.227-6.189 1.986 7.74-3.404 3.384zm-15.502-.127l4.887-4.856 4.807 4.936-4.886 4.856zm-7.814 7.765l4.886-4.856 4.81 4.936-4.888 4.856zm15.503.127l4.886-4.856L36.1 23.84l-4.887 4.856zM4.57 29.927l3.406-3.385 4.807 4.937-6.225 6.186zm14.021 1.598l4.887-4.856 4.808 4.936-4.886 4.856zm15.502.128l4.887-4.856 3.351 3.439-2.11 7.705zm-24.656 8.97l6.226-6.189 4.81 4.936-3.406 3.385zm16.843-1.206l4.886-4.856 6.126 6.289-7.662 2.007z"></path></g></svg><div>${label}</div>`,
    category: category,
    content: `
    <div id='stripe-payment-method-container' data-gjs-type="stripe-payment-methods">
      <button id="link-btn" class="btn btn-primary">
        Connect with Stripe
      </button>
    <div id="checkout"></div>
    </div>`,
  });
};
export default (dc, label, type, config) => {
  const defaultType = dc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  const { projectId, collections, pageCollection } = config;
  dc.addType(type, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          icon: `<svg height="10" viewBox="0 0 50 45" xmlns="http://www.w3.org/2000/svg">
          <g fill="#c3cfe9" fill-rule="evenodd">
          <path d="M102.473 32.722h4.489V14.934h-4.489zM124.39 18.268a7.376 7.376 0 00-2.14-2.053c-1.355-.854-3.204-1.28-5.545-1.28h-5.914v17.787h6.918c2.5 0 4.506-.817 6.02-2.453 1.514-1.635 2.27-3.805 2.27-6.508 0-2.15-.537-3.981-1.61-5.493m-7.182 10.427h-1.927v-9.734h1.954c1.373 0 2.428.43 3.168 1.287.74.857 1.11 2.073 1.11 3.647 0 3.2-1.435 4.8-4.305 4.8M18.637 0L4.09 3.81.081 18.439l5.014 5.148L0 28.65l3.773 14.693 14.484 4.047 5.096-5.064 5.014 5.147 14.547-3.81 4.008-14.63-5.013-5.146 5.095-5.063L43.231 4.13 28.745.083l-5.094 5.063zM9.71 6.624l7.663-2.008 3.351 3.44-4.887 4.856zm16.822 1.478l3.405-3.383 7.63 2.132-6.227 6.187zM4.672 17.238l2.111-7.705 6.125 6.288-4.886 4.856zm29.547-1.243l6.227-6.189 1.986 7.74-3.404 3.384zm-15.502-.127l4.887-4.856 4.807 4.936-4.886 4.856zm-7.814 7.765l4.886-4.856 4.81 4.936-4.888 4.856zm15.503.127l4.886-4.856L36.1 23.84l-4.887 4.856zM4.57 29.927l3.406-3.385 4.807 4.937-6.225 6.186zm14.021 1.598l4.887-4.856 4.808 4.936-4.886 4.856zm15.502.128l4.887-4.856 3.351 3.439-2.11 7.705zm-24.656 8.97l6.226-6.189 4.81 4.936-3.406 3.385zm16.843-1.206l4.886-4.856 6.126 6.289-7.662 2.007z"></path></g></svg>`,
          projectId: projectId,
          traits: [
            {
              name: 'stripe-customer-id-collection',
              type: 'select',
              label: 'Stripe Customer Id Collection',
              options: [
                { value: '', name: '-- Select --' },
                { value: 'PAGE_COLLECTION', name: 'Page Collection' },
                { value: 'CURRENT_USER', name: 'Current LoggedIn User Collection' },
              ],
              changeProp: 1,
            },
          ],
          script: function () {
            const stripebtn = document.getElementById('link-btn');
            stripebtn.onclick = (e) => {
              e.preventDefault();
              if (typeof processStripePaymentMethod !== 'undefined') {
                processStripePaymentMethod(this);
              }
            };
          },
        },
        init() {
          const attrs = this.getAttributes();
          const stripeField = attrs['stripe-customer-id-field'];
          if (stripeField) this.handleStripeCustomerIdCollectionChange();

          this.on(
            'change:stripe-customer-id-collection',
            this.handleStripeCustomerIdCollectionChange,
          );
          this.on('change:stripe-customer-id-field', this.handleStripeCustomerIdFieldChange);
        },
        async handleStripeCustomerIdCollectionChange() {
          const stripeCollection = this.get('stripe-customer-id-collection');
          const attrs = this.getAttributes();
          attrs['stripe-customer-id-collection'] = stripeCollection;
          this.setAttributes(attrs);
          const fieldOptions = await getStripeFieldsOptions(
            stripeCollection,
            collections,
            pageCollection,
          );
          this.removeTrait('stripe-customer-id-field');
          const fieldTrait = {
            type: 'select',
            label: 'Customer Id Field',
            name: 'stripe-customer-id-field',
            changeProp: 1,
            options: fieldOptions,
            value: '',
          };
          this.addTrait(fieldTrait, {
            at: this.getTraitIndex('stripe-customer-id-collection') + 1,
          });
        },
        handleStripeCustomerIdFieldChange() {
          const stripeField = this.get('stripe-customer-id-field');
          const attrs = this.getAttributes();
          attrs['stripe-customer-id-field'] = stripeField;
          this.setAttributes(attrs);
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') == type) {
            return {
              type: type,
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      events: {
        submit(e) {
          e.preventDefault();
        },
      },
      init({ model }) {
        this.listenTo(model, 'change:stripe-customer-id-collection', this.updateScript);
        this.listenTo(model, 'change:stripe-customer-id-field', this.updateScript);
      },
    }),
  });
};

export const getStripeFieldsOptions = async (stripeCollection, collections, pageCollection) => {
  let fieldOptions = [{ label: '- Select Field - ', value: '' }];
  switch (stripeCollection) {
    case 'PAGE_COLLECTION':
      fieldOptions = pageCollection.options;
      break;
    case 'CURRENT_USER':
      const userCollection = collections.find((coll) => coll.collectionName === 'user');
      fieldOptions = await getCollectionFieldTraitOptions(userCollection, collections);
      break;
    default:
      break;
  }
  return fieldOptions;
};
